var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-menu',{staticClass:"menu",attrs:{"default-active":_vm.selfActiveTab,"mode":"horizontal"},on:{"select":_vm.select}},_vm._l((_vm.menuTab),function(item,index){return _c('el-menu-item',{key:index,staticClass:"menu-item",class:{choose: index.toString() == _vm.selfActiveTab},attrs:{"index":index.toString()}},[_vm._v("\n    "+_vm._s(item)+"\n  ")])}),1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3cb86c41","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/activity/NavMenu.vue
// module id = null
// module chunks = 